var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRemovePin = function SvgRemovePin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m4.656 5.747-1.422-.624a1 1 0 0 0-1.104.207l-.322.322L4.645 8.49l-.78.78A18 18 0 0 0 1 13a18 18 0 0 0 3.73-2.865l.78-.78 2.838 2.837.322-.322a1 1 0 0 0 .207-1.104l-.624-1.422M8.253 9.344a7.1 7.1 0 0 1 1.814-3.093l.608-.608.977.241a1 1 0 0 0 .942-.263L13 5.215l-1.349-1.349-.064-.064L8.785 1l-.406.406a1 1 0 0 0-.263.942l.24.977-.667.656a7.1 7.1 0 0 1-2.97 1.748M4.526 8.362l.985.993M3.956 2.455l7.643 7.643"
  })));
};
export default SvgRemovePin;